import { Container, Box, Grid, Typography, Stack } from "@mui/material";
import SupportIcon from "../../../assets/support.png";
import PhoneIcon from "../../../assets/phone-contactus.png";
import ChatIcon from "../../../assets/chat.png";
import MessangerIcon from "../../../assets/messanger.png";
import { useTranslation } from "react-i18next";
import "./Support.css";

const Support = () => {
  const { t } = useTranslation();

  return (
    <Box sx={{ bgcolor: "background.default", py: 7 }}>
      <Container maxWidth="xl">
        <Grid
          container
          sx={{
            bgcolor: "#12132A",
            borderRadius: "50px",
            py: 10,
            px: 2,
            pt: 3.5,
          }}
          alignItems={"stretch"}
        >
          <Grid item xs={12} md={6} lg={3} mt={{ xs: "0", md: "0" }}>
            <Stack
              alignItems={"center"}
              marginRight={1}
              marginLeft={1}
              border={"1px solid rgba(245, 245, 245, 0.65)"}
              justifyContent={"center"}
              px={2}
              py={3.5}
              borderRadius={10}
              height={"100%"}
              bgcolor={"background.default"}
            >
              <Box className="image_icon_support">
                <img src={SupportIcon} alt="icon" width="auto" />
              </Box>
              <Typography
                variant="h6"
                sx={{ textAlign: "center", mt: 2, color: "text.title" }}
                className="span_intro_support2"
              >
                {t("full_time_support")}
              </Typography>
              <Typography
                variant="subtitle1"
                sx={{ textAlign: "center", mt: 2, mb: 2, color: "text.title" }}
                className="span_intro_support"
              >
                ما بصورت شبانه روزی در تمامی ایام آماده پشتیبانی هستیم
              </Typography>
            </Stack>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            lg={3}
            mt={{ xs: "5rem", sm: "5rem", md: "0", lg: "0" }}
          >
            <Stack
              alignItems={"center"}
              marginRight={1}
              marginLeft={1}
              border={"1px solid rgba(245, 245, 245, 0.65)"}
              justifyContent={"center"}
              height={"100%"}
              px={2}
              py={3.5}
              borderRadius={10}
              bgcolor={"background.default"}
            >
              <Box className="image_icon_support">
                <img src={PhoneIcon} alt="icon" width="auto" />
              </Box>
              <Typography
                variant="h6"
                sx={{ textAlign: "center", mt: 2, color: "text.title" }}
                bgcolor={"background.default"}
              >
                {t("phone_call")}
              </Typography>
              <Typography
                variant="subtitle1"
                sx={{ textAlign: "center", mt: 2, mb: 2, color: "text.title" }}
                className="span_intro_support"
              >
                شما می توانید مشکلات و درخواست هایتان را تلفنی با ما مطرح کنید
              </Typography>
            </Stack>
          </Grid>
          <Grid item xs={12} md={6} lg={3} mt={{ xs: "5rem", lg: "0" }}>
            <Stack
              alignItems={"center"}
              marginRight={1}
              marginLeft={1}
              border={"1px solid rgba(245, 245, 245, 0.65)"}
              justifyContent={"center"}
              height={"100%"}
              px={2}
              py={3.5}
              borderRadius={10}
              bgcolor={"background.default"}
            >
              <Box className="image_icon_support">
                <img src={ChatIcon} alt="icon" width="auto" />
              </Box>
              <Typography
                variant="h6"
                sx={{ textAlign: "center", mt: 2, color: "text.title" }}
                className="span_intro_support2"
              >
                {t("online_chat")}
              </Typography>
              <Typography
                variant="subtitle1"
                sx={{ textAlign: "center", mt: 2, mb: 2, color: "text.title" }}
                className="span_intro_support"
              >
                به کمک چت آنلاین می توانید با پشتیبان های ما در ارتباط باشید
              </Typography>
            </Stack>
          </Grid>
          <Grid item xs={12} md={6} lg={3} mt={{ xs: "5rem", lg: "0" }}>
            <Stack
              alignItems={"center"}
              marginRight={1}
              marginLeft={1}
              border={"1px solid rgba(245, 245, 245, 0.65)"}
              justifyContent={"center"}
              height={"100%"}
              px={2}
              py={3.5}
              borderRadius={10}
              bgcolor={"background.default"}
            >
              <Box className="image_icon_support">
                <img src={MessangerIcon} alt="icon" width="auto" />
              </Box>
              <Typography
                variant="h6"
                sx={{ textAlign: "center", mt: 2, color: "text.title" }}
                className="span_intro_support2"
              >
                {t("messanger")}
              </Typography>
              <Typography
                variant="subtitle1"
                sx={{ textAlign: "center", mt: 2, mb: 2, color: "text.title" }}
                className="span_intro_support"
              >
                همچنین می توانید با ما در پیام رسان ها در ارتباط باشید
              </Typography>
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Support;
